import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {WinConfig, WinConfigUtil} from "../../../utils/WinConfigUtil";
import {TheCage} from "../../../TheCage";
import {TheCageGameMode} from "../../../server/TheCageGameMode";
import {TheCageStatics} from "../../../config/TheCageStatics";
import {TheCageSound} from "../../../sound/TheCageSound";
import {TheCageModel} from "../../../server/TheCageModel";


/**
 * Created by jonas on 2022-01-12.
 */

export class WinSummery implements SimplePresentation {

    name:string = "WinSummery";

    constructor() {
    }

    private getAllConfigsForLevel(levelName:string, winConfigs:WinConfig[]) {
        const result = [];
        for(let conf of winConfigs) {
            if(conf.name == levelName) {
                result.push(conf);
            }
        }
        return result;
    }

    shouldRun():boolean {
        return TheCage.model.winData.accumulatedWinRatio > 0 && TheCage.model.data.nextMode == TheCageGameMode.NORMAL && !TheCage.model.gameData.brokeTheBank && !TheCage.isWinBelowStake();
    }

    start(controller:SimplePresentationRunnerController):void {

        //const tl:gsap.core.Timeline = gsap.timeline({onComplete : () => controller.finish()});
        const tl:gsap.core.Timeline = gsap.timeline();
        const isBigWin = TheCage.model.winData.accumulatedWinRatio >= 18;

        const belowStakeWinRestriction = TheCage.isWinBelowStake();

        //-----------DATA STUFF
        const multiplier = 1;
        let winConfigs:WinConfig[] = [];
        for(let i:number = 1; i <= multiplier; i++) {
            const startRatio = TheCage.model.winData.accumulatedWinRatio * (i - 1);
            const endRatio = TheCage.model.winData.accumulatedWinRatio * i;

            if(isBigWin) {
                winConfigs = winConfigs.concat(WinConfigUtil.getBigWinLevels(startRatio, endRatio, i, i == multiplier));
            }
            else {
                winConfigs = winConfigs.concat(WinConfigUtil.getNormalWinLevels(startRatio, endRatio, i, i == multiplier));
            }
        }

        const shouldCrossfadeMusic = !(TheCage.model.data.mode == TheCageGameMode.FREESPIN || TheCage.model.data.mode == TheCageGameMode.FREESPIN_AVALANCHE) &&
                                     (isBigWin || winConfigs.some((conf:WinConfig) => conf.name == "LARGE"));

        const lastLevelName = winConfigs[winConfigs.length - 1].name;
        if(isBigWin) {
            //This makes sure that the last bigwin level is played in full duration but only to the win amount. With the multipliers spaced out based on the multiplier ratio.
            let lastLevelConfigs = this.getAllConfigsForLevel(lastLevelName, winConfigs);
            for(let config of lastLevelConfigs) {
                config.durationRatio = config.calculateDurationNew(lastLevelConfigs[0].fromRatio, lastLevelConfigs[lastLevelConfigs.length - 1].toRatio);
            }
        }


        const lastLevelConfig:WinConfig = winConfigs[winConfigs.length - 1].clone();

        if(!isBigWin) {
            //Normal wins:
            tl.add(() =>{
                controller.setSkipCallback(() => tl.seek("ending", false));
            } , 0);
            const firstNormal = winConfigs[0];
            const lastNormal = winConfigs[winConfigs.length - 1];
            const normalWinTl = gsap.timeline();
            const skipCountSound = belowStakeWinRestriction || firstNormal.toRatio < 3; //below stake or < medium win.


            if(firstNormal.sound?.start && !skipCountSound) {
                normalWinTl.add(() => TheCage.soundPlayer.playSound(firstNormal.sound?.start!));
            }
            normalWinTl.add(TheCage.winView.getWinCountUp(
                firstNormal.fromRatio * TheCage.model.gameData.playedBetValue,
                lastNormal.toRatio * TheCage.model.gameData.playedBetValue,
                lastNormal.duration,
                0,
                undefined,
                skipCountSound
            ));
            //normalWinTl.add(Octagon.winView.getWinCountUpEnd(lastNormal.toRatio * Octagon.model.gameData.playedBetValue, 0.2));
            const timeDiff = Math.max(tl.duration() - normalWinTl.duration(), 0);
            tl.add(normalWinTl, timeDiff);

        }
        else {
            let prevConf;
            while(winConfigs.length > 0) {
                const config:WinConfig = winConfigs.shift()!;

                if(prevConf && prevConf.name == config.name) {
                    delete config.sound;
                    delete config.anim;
                }
                if(prevConf && prevConf.multiplier == config.multiplier) {
                    config.newMultiplier = false;
                }

                const labelName = config.name + "_x" + config.multiplier;

                const startDelay = config.name == "BIG_1" ? 0.714 : 0;
                tl.add(this.getBigWinLevel(config, TheCage.model.gameData.playedBetValue, winConfigs.length == 0));
                tl.add(TheCage.backgroundElements.getBounceShake(), '<');
                tl.add(() => controller.setSkipCallback(() => tl.seek(labelName, false)), `<${startDelay}`);
                tl.addLabel(labelName);
                prevConf = config;
            }
        }


        //Countup scale
        // no reason to check for regular freespins since we ever only do win summery once avalanches stop
        const countUpTarget = TheCage.model.gameData.mode == TheCageGameMode.FREESPIN_AVALANCHE
                              ? TheCage.model.gameData.totalAvalancheRoundWinnings
                              : TheCage.model.gameData.accumulatedRoundWin;
        tl.add(TheCage.winView.getCountUpScaleAnimation(0, countUpTarget, tl.duration(), 0.4, lastLevelConfig.textScale), 0);


        //tl.add(()=>Octagon.coinRain.stopAll());
        tl.addLabel("ending");
        tl.add(() => {controller.setSkipCallback();});

        //const useTotalWin = TheCage.model.gameData.accumulatedRoundWin != TheCage.model.gameData.totalSpinWinnings || TheCage.model.data.mode != TheCageGameMode.NORMAL;
        const stayDuration = isBigWin ? 2 : 1;
        tl.add(() => TheCage.keypadPlugin.setWin(TheCage.model.gameData.accumulatedRoundWin, true, TheCage.isWinBelowStake()));


        const endSound = lastLevelConfig.sound?.end;
        if(endSound && !belowStakeWinRestriction) {
            tl.add(() => TheCage.soundPlayer.stopWinSound());
            tl.add(() => TheCage.soundPlayer.playSound(endSound));
        }


        if (shouldCrossfadeMusic) {
            tl.add(() => {TheCage.soundPlayer.crossfadeToMain2()})
        }
        tl.add(() => {TheCage.soundPlayer.fadeInMusic(1000)});

        if (!belowStakeWinRestriction && TheCage.isWinAboveStake()){
            let particle = isBigWin ? 5 :  lastLevelConfig.particleLevel;
            let pos = isBigWin ? new PIXI.Point(360, 550) : new PIXI.Point(360, 360);
            tl.add(()=>{TheCage.winView.particleBurst.playAnimation(particle, pos)});
        }

        tl.add([
            TheCage.winView.getBigWinEnd(stayDuration),
            TheCage.winView.getWinCountUpEnd(TheCage.model.winData.accumulatedWin, stayDuration, 0),
        ]);


        tl.add(() => {
            TheCage.winView.getWinCountUpFade(TheCage.model.winData.accumulatedWin, stayDuration * 0.35);
        });
        tl.add(() => {
            controller.finish();
        });
        tl.add(gsap.to(this, {duration: stayDuration * 0.35}));

    }

    private getBigWinLevel(bigWinConfig:WinConfig, playedBetValue:number, lastLevel:boolean):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if(bigWinConfig.newMultiplier && bigWinConfig.multiplier > 1) {
            tl.add(() => {TheCage.winView.getMultiplier(bigWinConfig.multiplier, lastLevel, 0.2, true)});
            tl.add(TheCage.winView.getWinCountUpEnd(bigWinConfig.fromRatio * playedBetValue, 0.0));
        }

        const startDelay = bigWinConfig.name == "BIG_1" ? 0.714: 0;

        const countUp = TheCage.winView.getWinCountUp(
            bigWinConfig.fromRatio * playedBetValue,
            bigWinConfig.toRatio * playedBetValue,
            bigWinConfig.duration * bigWinConfig.durationRatio - startDelay,
            0,
            new PIXI.Point(360, 550),
            true,
            true
        );

        tl.add(countUp, `<${startDelay}`);

        if(bigWinConfig.sound && bigWinConfig.sound.start) {
            tl.add(() => {
                TheCage.soundPlayer.playWinSound(bigWinConfig.sound!.start!);
            }, 0)
        }

        if(bigWinConfig.isBigWin) {
            tl.add(() => {
                // Octagon.soundPlayer.startBigWinMusic();
                TheCage.soundPlayer.fadeOutMusic(300);
            }, 0)
        }

        if(bigWinConfig.anim) {
            tl.add(() => {TheCage.winView.getBigWinAnimation(bigWinConfig.anim!, bigWinConfig.particleLevel)}, 0);
            tl.add(()=>{TheCage.winView.particleBurst.playAnimation(5, new PIXI.Point(360, 550))},0);
        }

/*        tl.add(()=>Octagon.coinRain.stopAll(),0);
        tl.add(()=>Octagon.coinRain.startBigWinRain(bigWinConfig.particleLevel),0);*/


        return tl;
    }


}